const path = document.getElementById("path"),
  parentThemePath = document.getElementById("parent-theme-path"),
  shortcodeTemplate = document.getElementById("template"),
  shortcodeType = document.getElementById("type"),
  shortcodeSearchType = document.getElementById("search__type"),
  shortcodeSearchCountry = document.getElementById("search__country"),
  shortcodeSearchLanguage = document.getElementById("search__language"),
  shortcodeGeolocalisation = document.getElementById("geolocalisation"),
  storeContainer = document.getElementById("map__stores"),
  mapContainer = document.getElementById("map-content"),
  storeTab = document.getElementById("tab-list"),
  mapTab = document.getElementById("tab-map"),
  breakpoint = 768,
  markerSize = 40,
  markers = [],
  weekDay = [
    "Lundi",
    "Mardi",
    "Mercredi",
    "Jeudi",
    "Vendredi",
    "Samedi",
    "Dimanche"
  ],
  $ = jQuery.noConflict(),
  variables = {};

if (path !== null) {
  const params = { type: shortcodeType.value };
  variables.shortcodeTypeValue = shortcodeType.value;
  variables.shortcodeTemplateValue = shortcodeTemplate.value.toLowerCase();
  variables.shortcodeSearchTypeValue = shortcodeSearchType.value;
  variables.shortcodeSearchCountryValue = shortcodeSearchCountry.value;
  variables.shortcodeSearchCountryValue = shortcodeSearchCountry.value;
  variables.shortcodeSearchLanguageValue = shortcodeSearchLanguage.value;
  variables.shortcodeGeolocalisationValue = shortcodeGeolocalisation.value;
  // prettier-ignore
  variables.url = new URL(`${window.location.href.match("http://localhost") ? "http:" : ""}${parentThemePath.value}/assets/inc/json.inc.php`);
  variables.path = path.value;
  variables.parentThemePath = parentThemePath.value;
  variables.params = params;
  variables.breakpoint = breakpoint;
  variables.markerSize = markerSize;
  variables.weekDay = weekDay;
  variables.markers = markers;
  variables.storeContainer = storeContainer;
  variables.mapContainer = mapContainer;
  variables.storeTab = storeTab;
  variables.mapTab = mapTab;
}

export { variables, $ };
